/**
 * Domyślna konfiguracja sceny synth
 */
export const defaultConfig = {
    sun: {
        size: 50,
        positionX: 0,
        positionY: 0.3,
        color: 0xff00ff
    },
    mountains: {
        distortion: 0.5,
        height: 100,
        segments: 50
    },
    ground: {
        distortion: 0.2,
        gridSize: 50,
        speed: 0.5,
        linesCount: 10,
        lineWidth: 1,
        glowIntensity: 1.0,
        verticalRandomness: 0.5,
        blockNewSegments: false,
        bloom: {
            enabled: false,
            threshold: 0.8,
            strength: 1.5,
            radius: 0.4
        },
        lineBreaks: {
            horizontal: false,
            vertical: false,
            position: 'random',
            strength: 1.0,
            count: 2,
            skipVerticalForBreaks: false
        },
        useAltRoadRenderer: true // true = prostsza wersja (EdgesGeometry), false = stara wersja (TubeGeometry)
    },
    camera: {
        speed: 0.2,
        fov: 75
    },
    render: {
        pixelRatio: null,
        resolutionScale: 1.0
    }
};

